export default '/build/3fdd659f.svg'